export default __webpack_public_path__ + "static/media/clover.3c78440d.webp";